export default __webpack_public_path__ + "static/media/V280_CoC.98d65854.pdf";